import { useState, useCallback, useMemo, type ReactNode } from 'react';
import { ActiveLessonContext, type ActiveLessonState } from './useActiveLesson';

export function ActiveLessonProvider({ children }: { children: ReactNode }) {
  const [activeLesson, setActiveLessonState] = useState<ActiveLessonState | null>(null);

  const setActiveLesson = useCallback((state: ActiveLessonState) => {
    setActiveLessonState(state);
  }, []);

  const clearActiveLesson = useCallback(() => {
    setActiveLessonState(null);
  }, []);

  const value = useMemo(
    () => ({ activeLesson, setActiveLesson, clearActiveLesson }),
    [activeLesson, setActiveLesson, clearActiveLesson],
  );

  return (
    <ActiveLessonContext.Provider value={value}>
      {children}
    </ActiveLessonContext.Provider>
  );
}

export type { ActiveLessonState } from './useActiveLesson';
